module.exports = __webpack_public_path__ + "static/media/Character-04.87c5cd56.png";